import React, { useEffect } from 'react';
import style from './GoogleMap.module.scss';
import PlaceSvg from '../../assets/Place.svg'

function GoogleMap() {
    useEffect(() => {
        function initMap() {
            const map = new window.google.maps.Map(document.getElementById("map"), {
                center: { lat: 55.761482, lng: 37.605301 },
                zoom: 12,
                styles: [
                    { elementType: "geometry", stylers: [{ color: "#242f3e" }] },
                    { elementType: "labels.text.stroke", stylers: [{ color: "#242f3e" }] },
                    { elementType: "labels.text.fill", stylers: [{ color: "#746855" }] },
                    {
                        featureType: "administrative.locality",
                        elementType: "labels.text.fill",
                        stylers: [{ color: "#d59563" }],
                    },
                    {
                        featureType: "poi",
                        elementType: "labels.text.fill",
                        stylers: [{ color: "#d59563" }],
                    },
                    {
                        featureType: "poi.park",
                        elementType: "geometry",
                        stylers: [{ color: "#263c3f" }],
                    },
                    {
                        featureType: "poi.park",
                        elementType: "labels.text.fill",
                        stylers: [{ color: "#6b9a76" }],
                    },
                    {
                        featureType: "road",
                        elementType: "geometry",
                        stylers: [{ color: "#38414e" }],
                    },
                    {
                        featureType: "road",
                        elementType: "geometry.stroke",
                        stylers: [{ color: "#212a37" }],
                    },
                    {
                        featureType: "road",
                        elementType: "labels.text.fill",
                        stylers: [{ color: "#9ca5b3" }],
                    },
                    {
                        featureType: "road.highway",
                        elementType: "geometry",
                        stylers: [{ color: "#746855" }],
                    },
                    {
                        featureType: "road.highway",
                        elementType: "geometry.stroke",
                        stylers: [{ color: "#1f2835" }],
                    },
                    {
                        featureType: "road.highway",
                        elementType: "labels.text.fill",
                        stylers: [{ color: "#f3d19c" }],
                    },
                    {
                        featureType: "transit",
                        elementType: "geometry",
                        stylers: [{ color: "#2f3948" }],
                    },
                    {
                        featureType: "transit.station",
                        elementType: "labels.text.fill",
                        stylers: [{ color: "#d59563" }],
                    },
                    {
                        featureType: "water",
                        elementType: "geometry",
                        stylers: [{ color: "#17263c" }],
                    },
                    {
                        featureType: "water",
                        elementType: "labels.text.fill",
                        stylers: [{ color: "#515c6d" }],
                    },
                    {
                        featureType: "water",
                        elementType: "labels.text.stroke",
                        stylers: [{ color: "#17263c" }],
                    },
                ],
            });
            const customIcon = {
                url: PlaceSvg,
                scaledSize: new google.maps.Size(40, 40),
            };

            const myLatLng = { lat: 55.761482, lng: 37.605301 };
            const marker = new google.maps.Marker({
                position: myLatLng,
                map: map,
                icon: customIcon,
            });

            const contentString = '<div style="font-size: 18px;">Москва, Большой Гнездниковский переулок 1с2</div>';

            const infowindow = new google.maps.InfoWindow({
                content: contentString,
            });

            marker.addListener('click', function() {
                infowindow.open(map, marker);
            });
        }

        initMap();
    }, []);

    return (
        <div className={style.map} id="map" ></div>
    );
}

export default GoogleMap;
